import { message } from "utils/ciq-message";

export const MATERIAL_SUBMIT_SUCCESS_MESSAGE_KEY = "material-submit-success";
export const MATERIAL_SUBMIT_SUCCESS_DURATION_SECONDS = 10;

type ShowMaterialSubmitSuccessMessageParams = {
  activeMaterialIndex: number;
  totalMaterials: number;
  onNavigateToNext: () => void;
};

export function showMaterialSubmitSuccessMessage({
  activeMaterialIndex,
  totalMaterials,
  onNavigateToNext
}: ShowMaterialSubmitSuccessMessageParams) {
  const isLastMaterial =
    totalMaterials > 1 && activeMaterialIndex >= totalMaterials - 1;
  const canNavigateToNext =
    totalMaterials > 1 && activeMaterialIndex < totalMaterials - 1;

  let content: React.ReactNode;

  if (totalMaterials <= 1) {
    content = "Response submitted.";
  } else if (isLastMaterial) {
    content =
      "Response submitted. Please ensure all Materials have been responded to.";
  } else if (canNavigateToNext) {
    content = (
      <>
        Response submitted. Review submission or continue to the{" "}
        <button
          type="button"
          className="underline p-0 border-0 bg-transparent cursor-pointer text-inherit font-inherit"
          data-testid="material-submit-success-next-link"
          onClick={() => {
            message.destroy(MATERIAL_SUBMIT_SUCCESS_MESSAGE_KEY);
            onNavigateToNext();
          }}
        >
          next material
        </button>
        .
      </>
    );
  } else {
    content = "Response submitted.";
  }

  message.success({
    key: MATERIAL_SUBMIT_SUCCESS_MESSAGE_KEY,
    content,
    duration: MATERIAL_SUBMIT_SUCCESS_DURATION_SECONDS
  });
}
